// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KWO23o6PJHgJRGNdvc4F{justify-content:space-between;margin-bottom:13px;display:flex}.hHZpak0efQIo4cZ6Pct5{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryLine": `KWO23o6PJHgJRGNdvc4F`,
	"lineDesc": `hHZpak0efQIo4cZ6Pct5`
};
export default ___CSS_LOADER_EXPORT___;
